import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { UndergradSubmoduleState } from './state';
import { UndergradModule } from '@/models/undergrad/undergrad-module.model';

const getters: GetterTree<UndergradSubmoduleState, RootState> = {
  undergradSubmodules: (state: UndergradSubmoduleState): UndergradModule[] => {
    return Object.values(state.undergradSubmodules);
  },
};

export default getters;
